export default "__VITE_ASSET__BCM1VIXy__"